import { useEffect } from "react";

export function usePageTitleSetter(title: string, shouldSet: boolean = true) {
    useEffect(() => {
        if (shouldSet) {
            document.title = title;
        }
    }, [title, shouldSet]);
};